<template>
  <button :class="className" :type="type" class="yellow-button" @click="handleClick" @keydown.enter="handleClick">
    <slot />
  </button>
</template>

<script>
  const THEMES = ['main', 'outlined'];

  export default {
    name: 'YellowButton',

    emits: ['click', 'submit'],

    props: {
      type: {
        type: String,
        default: 'button',
      },
      theme: {
        type: String,
        default: 'main',
        validator: (value) => !value || THEMES.includes(value),
      },
    },

    computed: {
      className() {
        return `yellow-button--${this.theme}`;
      },
    },

    methods: {
      handleClick(event) {
        const eventType = this.type === 'submit' ? 'submit' : 'click';
        this.$emit(eventType, event);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .yellow-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: clamp(4px, 0.85vw, 12px) clamp(16px, 6vw, 24px);
    color: #1e1e1e;
    border-radius: var(--Spacing-m, 8px);
    background: linear-gradient(0deg, #f8bf1e 0%, #f8bf1e 100%), linear-gradient(180deg, #f3b506 0%, #f49910 100%);
    font-family: 'Inter', sans-serif;
    font-weight: 900;
    text-shadow: none;
    min-width: 130px;
    font-size: clamp(12px, 1.05vw, 22px);
    user-select: none;
    cursor: pointer;

    &--outlined {
      color: var(--Colors-White, #fff);
      background: transparent;
      box-shadow: 0 0 0 1px inset #f8bf1e;
    }

    &:hover {
      filter: brightness(104%);
    }

    &:active {
      filter: brightness(97%);
    }

    &[disabled] {
      pointer-events: none;
      border-radius: 10px;
      background: linear-gradient(180deg, #857e68 0%, #71685a 100%);
      box-shadow: none;
      color: #fff;
    }

    @media screen and (min-width: 1024px) {
      border-radius: 8px;
      font-size: clamp(14px, 1.25vw, 21px);
      padding: clamp(6px, 0.65vw, 12px) clamp(16px, 6vw, 24px);
    }

    @media screen and (min-width: 1280px) {
      font-size: clamp(14px, 1.2vw, 22px);
      padding: clamp(6px, 0.75vw, 12px) clamp(20px, 7vw, 30px);
      max-height: 60px;
    }
  }
</style>
